import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; 
import { Container, Form, Button, Row, Col, Card, Table } from 'react-bootstrap';
import '../styles/presupuesto.css'; // Importa tus estilos personalizados
import BotonMenu from './BotonMenu';
import Banners from './Banners';

const PresupuestoDetallado = () => {
    const navigate = useNavigate(); 
    // Estado para el nombre del cliente (campo de texto separado)
    const [nombreCliente, setNombreCliente] = useState('');

    // Estado para almacenar los valores de los inputs mensuales (numéricos)
    const [monthlyValues, setMonthlyValues] = useState({});
    // Estado para almacenar los valores anuales calculados
    const [annualValues, setAnnualValues] = useState({});

    // Estados para los totales
    const [totalIngresosMensual, setTotalIngresosMensual] = useState(0);
    const [totalIngresosAnual, setTotalIngresosAnual] = useState(0);
    const [totalEgresosMensual, setTotalEgresosMensual] = useState(0);
    const [totalEgresosAnual, setTotalEgresosAnual] = useState(0);
    const [balanceMensual, setBalanceMensual] = useState(0);
    const [balanceAnual, setBalanceAnual] = useState(0);

    // Definición de las entradas del presupuesto
    // Se usa 'type' para distinguir encabezados/subencabezados de los campos de input
    const budgetItems = [
        { type: 'heading', label: 'Ingresos' },
        { label: 'Sueldo Mensual neto', name: 'sueldoMensualNeto', category: 'ingreso' },
        { label: 'Comisiones', name: 'comisiones', category: 'ingreso' },
        { label: 'Bonos *', name: 'bonos', category: 'ingreso' },
        { label: 'Aguinaldo', name: 'aguinaldo', category: 'ingreso' },
        { label: 'Vacaciones', name: 'vacaciones', category: 'ingreso' },
        { label: 'Servicios Profesionales*', name: 'serviciosProfesionales', category: 'ingreso' },
        { label: 'Otros Ingresos:', name: 'otrosIngresos', category: 'ingreso' },

        { type: 'heading', label: 'Egresos Totales' },
        { type: 'subheading', label: '1. CASA' },
        { label: 'Cuota: Préstamo / Alquiler', name: 'cuotaAlquiler', category: 'egreso' },
        { label: 'Vigilancia', name: 'vigilancia', category: 'egreso' },
        { label: 'Alcaldía', name: 'alcaldia', category: 'egreso' },
        { label: 'Electricidad', name: 'electricidad', category: 'egreso' },
        { label: 'Agua - potable', name: 'aguaPotable', category: 'egreso' },
        { label: 'Agua - embotellada', name: 'aguaEmbotellada', category: 'egreso' },
        { label: 'Gas propano', name: 'gasPropano', category: 'egreso' },
        { label: 'Celular', name: 'celular', category: 'egreso' },
        { label: 'Internet / Fijo / Cable', name: 'internetFijoCable', category: 'egreso' },
        { label: 'Servicio domestico', name: 'servicioDomestico', category: 'egreso' },
        { label: 'Jardinero', name: 'jardinero', category: 'egreso' },
        { label: 'Mantenimiento de casa', name: 'mantenimientoCasa', category: 'egreso' },
        { label: 'Compra y reparación de artículos del hogar', name: 'compraReparacionHogar', category: 'egreso' },
        { label: 'Otros Egresos Casa:', name: 'otrosEgresosCasa', category: 'egreso' },

        { type: 'heading', label: '2. ALIMENTACIÓN' },
        { label: 'Mercado', name: 'mercado', category: 'egreso' },
        { label: 'Supermercado', name: 'supermercado', category: 'egreso' },
        { label: 'Limpieza e higiene personal', name: 'limpiezaHigienePersonal', category: 'egreso' },
        { label: 'Alimentación en trabajo y colegio', name: 'alimentacionTrabajoColegio', category: 'egreso' },
        { label: 'Otros Alimentación:', name: 'otrosAlimentacion', category: 'egreso' },

        { type: 'heading', label: '3. VEHÍCULOS / TRANSPORTE' },
        { label: 'Cuota: Préstamo - Vehículo(s)', name: 'cuotaPrestamoVehiculo', category: 'egreso' },
        { label: 'Combustible', name: 'combustible', category: 'egreso' },
        { label: 'Limpieza / Parqueos', name: 'limpiezaParqueos', category: 'egreso' },
        { label: 'Mantenimiento - Correctivo y Preventivo', name: 'mantenimientoVehiculo', category: 'egreso' },
        { label: 'Otros Vehículos:', name: 'otrosVehiculos', category: 'egreso' },
        { type: 'subheading', label: 'Prov. Vehículos' },
        { label: 'Prov. - Tarjeta Circulación / Licencia', name: 'provTarjetaCirculacionLicencia', category: 'egreso' },
        { label: 'Prov. - Mantenimiento - Correctivo y Preventivo', name: 'provMantenimientoVehiculoProv', category: 'egreso' },

        { type: 'heading', label: '4. SEGUROS' },
        { label: 'Vida', name: 'seguroVida', category: 'egreso' },
        { label: 'Gastos médicos', name: 'seguroGastosMedicos', category: 'egreso' },
        { label: 'Incapacidad', name: 'seguroIncapacidad', category: 'egreso' },
        { label: 'Deuda - Vida', name: 'seguroDeudaVida', category: 'egreso' },
        { label: 'Deuda - Daños', name: 'seguroDeudaDanos', category: 'egreso' },
        { label: 'Residencia (Daños)', name: 'seguroResidencia', category: 'egreso' },
        { label: 'Vehículos', name: 'seguroVehiculos', category: 'egreso' },
        { label: 'Servicio de Asistencia (T/C)', name: 'seguroServicioAsistencia', category: 'egreso' },
        { label: 'Fraude y Robo (T/C)', name: 'seguroFraudeRobo', category: 'egreso' },
        { label: 'Otros Seguros/Anuales:', name: 'otrosSegurosAnuales', category: 'egreso' },

        { type: 'heading', label: '5. ENTRETENIMIENTO' },
        { label: 'Comidas fuera', name: 'comidasFuera', category: 'egreso' },
        { label: 'Paseos', name: 'paseos', category: 'egreso' },
        { label: 'Vacaciones / Viajes', name: 'vacacionesViajes', category: 'egreso' },
        { label: 'Otros Entretenimiento:', name: 'otrosEntretenimiento', category: 'egreso' },
        { type: 'subheading', label: 'Prov. Entretenimiento' },
        { label: 'Prov. - Vacaciones / Viajes', name: 'provVacacionesViajes', category: 'egreso' },

        { type: 'heading', label: '6. AHORROS' },
        { label: 'Deudas bancarias', name: 'deudasBancarias', category: 'egreso' },
        { label: 'Deudas Bancarias - Pago Anticipado', name: 'deudasBancariasPagoAnticipado', category: 'egreso' },
        { label: 'Tarjetas de Crédito', name: 'tarjetasCredito', category: 'egreso' },

        { type: 'heading', label: '7. ROPA' },
        { label: 'Compra / Reparación de Ropa', name: 'compraReparacionRopa', category: 'egreso' },
        { label: 'Otros - Anual de Ropa:', name: 'otrosAnualRopa', category: 'egreso' },

        { type: 'heading', label: '8. SALUD' },
        { label: 'Médicos', name: 'medicos', category: 'egreso' },
        { label: 'Dentistas', name: 'dentistas', category: 'egreso' },
        { label: 'Medicinas', name: 'medicinas', category: 'egreso' },
        { label: 'Exámenes', name: 'examenes', category: 'egreso' },
        { type: 'subheading', label: 'Prov. Salud' },
        { label: 'Prov. - Gastos Médicos', name: 'provGastosMedicos', category: 'egreso' },

        { type: 'heading', label: '9. EDUCACIÓN' },
        { label: 'Colegiatura mensual', name: 'colegiaturaMensual', category: 'egreso' },
        { label: 'Materiales y Útiles', name: 'materialesUtiles', category: 'egreso' },
        { label: 'Otros Educación:', name: 'otrosEducacion', category: 'egreso' },
        { type: 'subheading', label: 'Prov. Educación' },
        { label: 'Prov. - Matricula anual / Unif. / Útiles', name: 'provMatriculaAnualUnifUtiles', category: 'egreso' },

        { type: 'heading', label: '10. MISCELÁNEOS' },
        { label: 'Dry cleaning', name: 'dryCleaning', category: 'egreso' },
        { label: 'Salón de belleza / Peluquería', name: 'salonBellezaPeluqueria', category: 'egreso' },
        { label: 'Suscripciones (Periódicos, Revistas, etc.)', name: 'suscripciones', category: 'egreso' },
        { label: 'Mensualidades', name: 'mensualidades', category: 'egreso' },
        { label: 'Membresías: Club social / Otros', name: 'membresiasClubSocial', category: 'egreso' },
        { label: 'Extracurriculares: (Gimnasio / Clases / Otros)', name: 'extracurriculares', category: 'egreso' },
        { label: 'Diezmo / Ayudas / Colectas', name: 'diezmoAyudasColectas', category: 'egreso' },
        { label: 'Masajes', name: 'masajes', category: 'egreso' },
        { label: 'Cosméticos y Limpieza Facial', name: 'cosmeticosLimpiezaFacial', category: 'egreso' },
        { label: 'Regalos y Eventos', name: 'regalosEventos', category: 'egreso' },
        { label: 'Otros Misceláneos:', name: 'otrosMiscelaneos', category: 'egreso' },
        { type: 'subheading', label: 'Prov. Misceláneos' },
        { label: 'Prov. - Cosméticos y Limpieza facial', name: 'provCosmeticosLimpiezaFacial', category: 'egreso' },
        { label: 'Prov. - Seguros médicos y Hospit. / Compl. / Aniv.', name: 'provSegurosMedicos', category: 'egreso' },
        { label: 'Prov. - Reposición de Doc. (Pasaportes / DUI / Otros)', name: 'provReposicionDoc', category: 'egreso' },
        { type: 'subheading', label: 'Provisiones (Otras)' },
        { label: 'Prov. - Mantenimiento de casa', name: 'provMantenimientoCasa', category: 'egreso' },
        { label: 'Prov. - Compra y reparación de artículos del hogar', name: 'provCompraReparacionHogar', category: 'egreso' },
        { label: 'Prov. - Aguinaldos de empleados', name: 'provAguinaldosEmpleados', category: 'egreso' },

        { type: 'heading', label: '11. Inversiones' },
        { label: 'Inversiones', name: 'Inversiones', category: 'ingreso' },        
    ];


    // useEffect para recalcular los valores anuales y totales cuando cambian los mensuales
    useEffect(() => {
        calculateAnnualAndTotals();
    }, [monthlyValues]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setMonthlyValues(prevValues => ({
            ...prevValues,
            [name]: value,
        }));
    };

    const calculateAnnualAndTotals = () => {
        let currentTotalIngresosMensual = 0;
        let currentTotalEgresosMensual = 0;
        let newAnnualValues = {};

        budgetItems.forEach(item => {
            if (item.type === 'heading' || item.type === 'subheading') return; // Saltar encabezados

            const monthlyValue = parseFloat(monthlyValues[item.name]) || 0;
            let annualCalculatedValue = 0
            if(item.name != "vacaciones" && item.name != "serviciosProfesionales" && item.name != "bonos" && item.name != "aguinaldo"){
                 annualCalculatedValue = monthlyValue * 12;
            }else{
                 annualCalculatedValue = monthlyValue;
            }


            newAnnualValues[item.name] = annualCalculatedValue;

            if (item.category === 'ingreso') {
                currentTotalIngresosMensual += monthlyValue;
            } else if (item.category === 'egreso') {
                currentTotalEgresosMensual += monthlyValue;
            }
        });

        setAnnualValues(newAnnualValues);
        setTotalIngresosMensual(currentTotalIngresosMensual);
        setTotalIngresosAnual(currentTotalIngresosMensual * 12);
        setTotalEgresosMensual(currentTotalEgresosMensual);
        setTotalEgresosAnual(currentTotalEgresosMensual * 12);
        setBalanceMensual(currentTotalIngresosMensual - currentTotalEgresosMensual);
        setBalanceAnual((currentTotalIngresosMensual - currentTotalEgresosMensual) * 12);
    };

    // Función para renderizar una fila de input
    const renderInputRow = (item) => (
        <tr key={item.name}>
            <td className="text-start">
                <strong>{item.label}</strong>
            </td>
            <td>
                <Form.Control
                    type="number"
                    name={item.name}
                    value={monthlyValues[item.name] || ''}
                    onChange={handleChange}
                    step="0.01"
                    min="0"
                    placeholder="0.00"
                    className="text-center"
                />
            </td>
            <td>
                <Form.Control
                    type="number"
                    value={(annualValues[item.name] || 0).toFixed(2)}
                    readOnly
                    disabled
                    className="bg-light text-muted text-center"
                />
            </td>
        </tr>
    );

    // Función para renderizar encabezados de sección
    const renderHeadingRow = (item) => (
        <tr key={item.label} className="table-secondary">
            <td colSpan="3" className={item.type === 'heading' ? 'income-heading' : 'sub-heading'}>
                {item.label}
            </td>
        </tr>
    );

    return (
        <Container className="my-5">
            <Row className="justify-content-md-center">
                <Banners BannerShow={1} Act={1}></Banners>
                <Col md={8} lg={8}>
                <BotonMenu></BotonMenu>
                    <Card className="budget-card p-4" style={{ marginBottom: '20px' }}>
                        <Card.Title className="text-center mb-4 card-title h5">
                            <h2>Calculadora de presupuesto Personal</h2>
                        </Card.Title>

                        <Form.Group className="mb-4" controlId="nombreCliente">
                            <Form.Label className="fw-bold">Nombre:</Form.Label>
                            <Form.Control
                                type="text"
                                value={nombreCliente}
                                onChange={(e) => setNombreCliente(e.target.value)}
                                placeholder="Ingresa el nombre"
                            />
                        </Form.Group>

                        <Form>
                            <Table bordered responsive className="text-center table-budget">
                                <thead className="table-dark">
                                    <tr>
                                        <th>Gastos - Cuenta / Subcuentas</th>
                                        <th>Mensual ($)</th>
                                        <th>Anual ($)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {budgetItems.map((item, index) => {
                                        if (item.type === 'heading' || item.type === 'subheading') {
                                            return renderHeadingRow(item);
                                        }
                                        return renderInputRow(item);
                                    })}
                                    {/* Fila de Totales de Ingresos */}
                                    <tr className="table-success fw-bold total-row">
                                        <td className="text-end">Total Ingresos:</td>
                                        <td>${totalIngresosMensual.toFixed(2)}</td>
                                        <td>${totalIngresosAnual.toFixed(2)}</td>
                                    </tr>
                                    {/* Fila de Totales de Egresos */}
                                    <tr className="table-danger fw-bold total-row">
                                        <td className="text-end">Total Egresos:</td>
                                        <td>${totalEgresosMensual.toFixed(2)}</td>
                                        <td>${totalEgresosAnual.toFixed(2)}</td>
                                    </tr>
                                    {/* Fila de Balance Neto */}
                                    <tr className={`table-${balanceMensual >= 0 ? 'info' : 'warning'} fw-bold total-row`}>
                                        <td className="text-end">Balance Neto:</td>
                                        <td>${balanceMensual.toFixed(2)}</td>
                                        <td>${balanceAnual.toFixed(2)}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Form>
                        <Card.Footer className="text-muted text-center">
                            <small className="asterisk-note">.</small>
                            <Button variant="link" onClick={() => navigate('/calculadoras-financieras')} className="ms-2">
                                Ir a Calculadoras
                            </Button>   
                        </Card.Footer>
                    </Card>
                    <Row>
                        <Banners BannerShow={2} Act={1}></Banners>
                    </Row>                     
                </Col>
                <Banners BannerShow={1} Act={1}></Banners>
            </Row>
        </Container>
    );
};

export default PresupuestoDetallado;